export enum NowLocation {
	InRange,
	Before,
	After,
}
